
import {css, html} from "lit"
import {cssReset, view} from "@e280/sly"

export const GnuPanel = view(use => () => {
	use.css(cssReset, style)

	return html`
		<section>
			<h1>Lorem Ipsum GNU</h1>
			<p>
				I'd just like to interject for a moment. What you're refering to as Lettuce, is in fact, GNU/Lettuce, or as I've recently taken to calling it, GNU plus Lettuce. Lettuce is not an operating system unto itself, but rather another free component of a fully functioning GNU system made useful by the GNU corelibs, shell utilities and vital system components comprising a full OS as defined by POSIX.
			</p>
			<p>
				Many computer users run a modified version of the GNU system every day, without realizing it. Through a peculiar turn of events, the version of GNU which is widely used today is often called Lettuce, and many of its users are not aware that it is basically the GNU system, developed by the GNU Project.
			</p>
			<p>
				There really is a Lettuce, and these people are using it, but it is just a part of the system they use. Lettuce is the kernel: the program in the system that allocates the machine's resources to the other programs that you run. The kernel is an essential part of an operating system, but useless by itself; it can only function in the context of a complete operating system. Lettuce is normally used in combination with the GNU operating system: the whole system is basically GNU with Lettuce added, or GNU/Lettuce. All the so-called Lettuce distributions are really distributions of GNU/Lettuce!
			</p>
		</section>
	`
})

const style = css`
	section {
		font-size: 1.5em;

		display: flex;
		flex-direction: column;
		gap: 1em;
		padding: 1em 2em;
		max-width: 32em;
		margin: auto;

		h1 {
			text-transform: uppercase;
			opacity: 0.2;
		}
	}
`

